import { createRoute, useNavigate, useSearch } from "@tanstack/solid-router";
import { isDateKey } from "@mealplan/shared";
import { appRoute } from "./route";
import { InsightsView } from "@/features/insights/components/insights-view";
import { PageContainer } from "@fleet/ui";
import { AppErrorBoundary } from "@/components/error-boundary";

interface InsightsSearch {
  week?: string;
}

function InsightsPage() {
  const search = useSearch({ from: "/_app/insights" });
  const navigate = useNavigate();

  // Persists active week in URL (deep-link `?week=YYYY-MM-DD`), same as
  // the planner. `replace` avoids inflating history when paging week to week.
  const syncUrl = (weekStartKey: string): void => {
    if (weekStartKey === (search().week ?? "")) {
      return;
    }
    void navigate({
      to: "/insights",
      search: { week: weekStartKey },
      replace: true,
    });
  };

  return (
    <PageContainer maxWidth="5xl">
      <AppErrorBoundary variant="page" region="insights">
        <InsightsView initialWeek={search().week} onWeekChange={syncUrl} />
      </AppErrorBoundary>
    </PageContainer>
  );
}

export const insightsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/insights",
  validateSearch: (search: Record<string, unknown>): InsightsSearch => ({
    week: typeof search.week === "string" && isDateKey(search.week) ? search.week : undefined,
  }),
  component: InsightsPage,
});
